import React from 'react';
import { Text } from '../../../../../typography';
import { ClockIcon } from '../../../../../../assets/icons/ClockIcon';

export const AccessManagement2NPreview = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
    <ClockIcon />
    <Text size={20}>Coming soon</Text>

  </div>
);
